import { render, staticRenderFns } from "./PayRollPage.vue?vue&type=template&id=ec1ec61c&scoped=true&"
import script from "./PayRollPage.vue?vue&type=script&lang=js&"
export * from "./PayRollPage.vue?vue&type=script&lang=js&"
import style0 from "./PayRollPage.vue?vue&type=style&index=0&id=ec1ec61c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1ec61c",
  null
  
)

export default component.exports